module.exports = __webpack_public_path__ + "static/media/attr_maternity.94d926f9.svg";